"use client";

import { c as _c } from "react/compiler-runtime";
import { IconMagnifyingGlass } from "@central-icons-react/square-outlined-radius-0-stroke-1.5";
import { Input } from "@/components/ui/input";
import { useCommandMenuStore } from "@/stores/commandMenuStore";
import { useState } from "react";
interface PageHeaderProps {
  children?: React.ReactNode;
  onSearch?: (query: string) => void;
  searchPlaceholder?: string;
  showSearch?: boolean;
  useCommandMenu?: boolean;
  filters?: React.ReactNode;
  searchDataGuide?: string;
}
export function PageHeader(t0) {
  const $ = _c(26);
  const {
    children,
    onSearch,
    searchPlaceholder: t1,
    showSearch: t2,
    useCommandMenu: t3,
    filters,
    searchDataGuide
  } = t0;
  const searchPlaceholder = t1 === undefined ? "Search..." : t1;
  const showSearch = t2 === undefined ? true : t2;
  const useCommandMenu = t3 === undefined ? true : t3;
  const [searchQuery, setSearchQuery] = useState("");
  const setCommandMenuOpen = useCommandMenuStore(_temp);
  let t4;
  if ($[0] !== onSearch) {
    t4 = e => {
      const query = e.target.value;
      setSearchQuery(query);
      onSearch?.(query);
    };
    $[0] = onSearch;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const handleSearchChange = t4;
  let t5;
  if ($[2] !== setCommandMenuOpen || $[3] !== useCommandMenu) {
    t5 = () => {
      if (useCommandMenu) {
        setCommandMenuOpen(true);
      }
    };
    $[2] = setCommandMenuOpen;
    $[3] = useCommandMenu;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleSearchClick = t5;
  let t6;
  if ($[5] !== setCommandMenuOpen || $[6] !== useCommandMenu) {
    t6 = e_0 => {
      if (useCommandMenu && e_0.key === "k" && (e_0.metaKey || e_0.ctrlKey)) {
        e_0.preventDefault();
        setCommandMenuOpen(true);
      }
    };
    $[5] = setCommandMenuOpen;
    $[6] = useCommandMenu;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleSearchKeyDown = t6;
  let t7;
  if ($[8] !== children || $[9] !== showSearch) {
    t7 = children && <><div className="flex-1 shrink-0">{children}</div>{showSearch && <div className="bg-ds-neutral-200 dark:bg-ds-neutral-800 h-6 w-px" />}</>;
    $[8] = children;
    $[9] = showSearch;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== handleSearchChange || $[12] !== handleSearchClick || $[13] !== handleSearchKeyDown || $[14] !== searchDataGuide || $[15] !== searchPlaceholder || $[16] !== searchQuery || $[17] !== showSearch || $[18] !== useCommandMenu) {
    t8 = showSearch && <div className="relative min-w-0 flex-1" data-guide={searchDataGuide}><div className="relative flex items-center"><IconMagnifyingGlass className="text-ds-text-disabled absolute left-3 h-4 w-4" /><Input type="text" value={searchQuery} onChange={handleSearchChange} onKeyDown={handleSearchKeyDown} onClick={handleSearchClick} placeholder={searchPlaceholder} readOnly={useCommandMenu} className={`emboss-inner w-full rounded-lg py-2 pl-10 transition-colors focus-visible:ring-0 dark:bg-zinc-950 ${useCommandMenu ? "cursor-pointer pr-16" : "pr-4"}`} />{useCommandMenu && <kbd className="border-ds-border-default text-ds-text-subtle dark:bg-ds-neutral-800 dark:text-ds-text-disabled pointer-events-none absolute right-3 flex items-center gap-0.5 rounded border bg-zinc-50 px-2 py-0.5 text-xs font-medium">⌘K</kbd>}</div></div>;
    $[11] = handleSearchChange;
    $[12] = handleSearchClick;
    $[13] = handleSearchKeyDown;
    $[14] = searchDataGuide;
    $[15] = searchPlaceholder;
    $[16] = searchQuery;
    $[17] = showSearch;
    $[18] = useCommandMenu;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== filters) {
    t9 = filters && <div className="flex shrink-0 items-center gap-3">{filters}</div>;
    $[20] = filters;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t10 = <div className="border-ds-border-default flex items-center gap-4 border-b p-4">{t7}{t8}{t9}</div>;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function _temp(state) {
  return state.setOpen;
}